import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  spinner: {
    width: 60,
    height: 60,
    border: '6px solid rgba(5, 160, 217, 0.2)',
    borderTopColor: styles.palette.background.primary,
    borderRadius: '50%',
    animation: 'spin 1s infinite linear',
  },
});
